var map = {
	"./1WIN.svg": "458d",
	"./1XBET.svg": "96e4",
	"./1XSTAVKA.svg": "11fb",
	"./32RED.svg": "dcce",
	"./ASTEKBET.svg": "81b4",
	"./BATERY.svg": "c09b",
	"./BCGAME.svg": "bb06",
	"./BCGAME.webp": "ce15",
	"./BET365.ES.svg": "d9b5",
	"./BET365.GR.svg": "cd65",
	"./BET365.IT.svg": "00a4",
	"./BET365.RU.svg": "1582",
	"./BET365.svg": "ffd5",
	"./BETANDYOU.svg": "b230",
	"./BETBOOM.svg": "7c1f",
	"./BETCITY.svg": "5c3d",
	"./BETFAIR.ES.svg": "4347",
	"./BETFURY.svg": "c5ad",
	"./BETIRO.svg": "9366",
	"./BETPANDA.svg": "e1f1",
	"./BETSSON.svg": "ea0d",
	"./BETVICTOR.svg": "f03a",
	"./BETWAY.svg": "08f7",
	"./BETWINNER.svg": "8304",
	"./BFSPORTSBOOK.svg": "40ca",
	"./BITZ.svg": "2333",
	"./BWIN.svg": "cc71",
	"./CASINOWINNER.svg": "cb8a",
	"./CHIPS.GG.svg": "3c9e",
	"./CRASHINO.svg": "c44c",
	"./CRYPTOCASINO.svg": "73a8",
	"./CSGO500.png": "43cd",
	"./CSGO500.svg": "f006",
	"./DOUBLEBET.svg": "7a82",
	"./FAIRSPIN.svg": "3aa0",
	"./FANSPORT.svg": "9ed2",
	"./FAVBET.svg": "744b",
	"./FONBET.BY.svg": "3de0",
	"./FONBET.KZ.svg": "0979",
	"./FONBET.svg": "f86e",
	"./FORTUNE.svg": "315c",
	"./GAMDOM.svg": "7df2",
	"./GAMEBOOKERS.svg": "f2f9",
	"./JETTON.svg": "97bb",
	"./JUSTBIT.svg": "94fd",
	"./LADBROKES.svg": "cb17",
	"./LEON.svg": "e859",
	"./LIGASTAVOK.svg": "fa5b",
	"./LINEBET.svg": "1b54",
	"./LUCKYBLOCK.svg": "6594",
	"./MARATHON.svg": "89e1",
	"./MEGADICE.svg": "bcc5",
	"./MELBET.svg": "dba3",
	"./MOSTBET.svg": "c953",
	"./NORDICBET.svg": "06c3",
	"./OLIMP.KZ.svg": "1c72",
	"./OLIMP.svg": "66eb",
	"./PADDYPOWER.svg": "5b9e",
	"./PARIBET.svg": "5807",
	"./PARIMATCH.BY.svg": "a98c",
	"./PARIMATCH.UK.svg": "fcaf",
	"./PARIMATCH.svg": "dcd4",
	"./PARTYPOKER.svg": "a571",
	"./PINUP.svg": "1557",
	"./RAZED.png": "c3e2",
	"./ROLLBIT.svg": "0ec9",
	"./ROOBET.svg": "9dce",
	"./SBOBET.svg": "0405",
	"./SOLCASINO.svg": "8b18",
	"./SPORTINGBET.svg": "582a",
	"./STAKE.svg": "9347",
	"./TETHER.svg": "483d",
	"./UBET.svg": "e9e3",
	"./UNIBET.svg": "d479",
	"./VAVE.svg": "b642",
	"./VBET.svg": "c6be",
	"./WEISS.svg": "2d24",
	"./WEISS.webp": "5ce8",
	"./WILD.svg": "6693",
	"./WILLIAMHILL.svg": "3548",
	"./WINLINE.svg": "7b75",
	"./WSMCASINO.svg": "8539"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "574d";